enum InsuranceInfoStatus {
  NOT_STARTED = "NOT_STARTED",
  UPDATED = "UPDATED",
  PROCESSED = "PROCESSED",
  NO_INSURANCE = "NO_INSURANCE",
}

export default InsuranceInfoStatus;
